import { activeInActivePanelistStatusTypes } from "../types";
const initialState = {
    data: "",
    loading: false,
    error: "",
    activeOrInactiveStatus: ""
}
const reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case activeInActivePanelistStatusTypes.FETCH:
            return { ...state, loading: true }
        case activeInActivePanelistStatusTypes.SUCCESS:
            return { ...state, data: payload, loading: false, error: "", }
        case activeInActivePanelistStatusTypes.ERROR:
            return { ...state, loading: false, error: payload }
        case activeInActivePanelistStatusTypes.RESET:
            return initialState;
        default:
            return state;
    }
}

export default reducer;